import React, { useState } from "react";
import DialogModal from "../../../../elements/dialogModal/DialogModal";
import TwoFa from "../../../../elements/twoFa/TwoFa";
import axios from "axios";
import userAuthenticationConfig from "../../../../../utils/userAuthenticationConfig";
import { Alert } from "@material-ui/lab";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import Notification from "../../../../elements/notification/Notification";
import PageSpinner from "../../../../elements/spinner/PageSpinner";
import { check2FA } from "../../../../../utils/check2FA";
import getUserInfo from "../../../../../utils/getUserInfo";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../../styles/styledTable";
import { parseAxiosError } from "../../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../../utils/consts";

const ProjectWebhooksList = ({ t, actionsList, projectId, fetchActionList }) => {

  const [copy, setCopy] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});
  const [removedActionId, setRemovedActionId] = useState(null);
  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleRemove = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.delete("/api/actions/" + removedActionId, userAuthenticationConfig()).then(() => {
      setOpen(false);
      fetchActionList();
      setNotification({ ...notification, visible: true, type: "success", message: t("details.webhook.table.deleteMessage") });
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  if (!actionsList) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (actionsList.length === 0) {
    return <Alert severity="warning">{t("details.webhook.table.emptyData")}</Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("details.twoFa")}
        content={<TwoFa
          handleSubmit={handleRemove}
          error={error}
        />}
      />
      <StyledScrollTable>
        <StyledTable
          width="768"
          size="16"
          className="projects-webhooks-table"
        >
          <StyledTableHead
            scroll="auto"
            col="3"
            className="projects-webhooks-table__head"
          >
            <div>
              Action
            </div>
            <div>
              {t("details.webhook.table.link")}
            </div>
            <div />
          </StyledTableHead>
          <StyledTableBody>
            {actionsList && actionsList.map((value, key) => (
              <StyledTableRow
                key={key}
                scroll="auto"
                col="3"
                className="projects-webhooks-table__row"
              >
                <StyledCol>
                  {value.type}
                </StyledCol>
                <StyledCol>
                  <CopyToClipboard
                    text={value.url}
                    onCopy={() => {
                      setCopy(true);
                      setNotification({ ...notification, visible: true, type: "success", message: t("details.webhook.table.copied") });
                    }}
                  >
                    <div className="projects-webhooks-table__link">
                      {value.url}
                    </div>
                  </CopyToClipboard>
                </StyledCol>
                <StyledCol inline>
                  <button
                    className="table-action table-action_danger"
                    onClick={() => {
                      setRemovedActionId(value.id);
                      handleOpenDialog();
                    }}
                  >
                    {t("details.webhook.table.delete")}
                  </button>
                </StyledCol>
              </StyledTableRow>
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
    </>
  );
};

export default ProjectWebhooksList;